const NEED_TO_SET_IN_ENV = "need_to_set_in_env";
const ENV_CONFIG = {
    ENV: process.env.REACT_APP_ENV || NEED_TO_SET_IN_ENV,
    API_URL: process.env.REACT_APP_API_URL || NEED_TO_SET_IN_ENV ,
    API_KEY: process.env.REACT_APP_API_KEY || NEED_TO_SET_IN_ENV,
    MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN || NEED_TO_SET_IN_ENV,
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID || "postman"
};

export default ENV_CONFIG;